module.exports = __webpack_public_path__ + "static/media/edit_order_button.9dd76de9.svg";